import { Link } from "react-router-dom";
import { useState } from "react";

export default function Navbar() {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <nav className="navbar navbar-expand-lg navbar-dark shadow-sm sticky-top px-4 py-3" style={{ background: "rgba(0,0,0,0.9)" }}>
      <div className="container-fluid">
        {/* Brand Name */}
        <Link className="navbar-brand fw-bold fs-3" to="/">
          Cohall Leathers
        </Link>

        {/* Mobile Toggle */}
        <button 
          className="navbar-toggler" 
          type="button" 
          onClick={() => setIsOpen(!isOpen)}
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        {/* Navbar Links */}
        <div className={`collapse navbar-collapse ${isOpen ? "show" : ""}`}>
          <ul className="navbar-nav ms-auto text-center">
            <li className="nav-item">
              <Link className="nav-link fw-semibold px-3" to="/">Home</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link fw-semibold px-3" to="/products">Products</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link fw-semibold px-3" to="/about">About</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link fw-semibold px-3" to="/contact">Contact</Link>
            </li>
          </ul>
        </div>
      </div>

      <style>
        {`
          .nav-link {
            transition: all 0.3s ease;
          }
          .nav-link:hover {
            color: #f8d210 !important; /* Golden hover effect */
            transform: translateY(-2px);
          }
          .navbar-brand {
            transition: color 0.3s ease;
          }
          .navbar-brand:hover {
            color: #f8d210 !important;
          }
        `}
      </style>
    </nav>
  );
}
